import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Calendar } from "lucide-react";

const FloatingBookButton = () => {
  // Button moved to header on mobile/tablet, this component now hidden
  return null;
};

export default FloatingBookButton;
